import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add as AddIcon } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import { Centered, Paper, Space } from "../../../../../common/components/libs";
import {Trans, useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
    props => {
        return props.theme.spacing(6)
    }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;

interface Props {
    openForm: () => void;
}

const NoModifiersInChooseOneSet = (props: Props) => {
    const {t} = useTranslation(["general", "menu"]);
    return <>
        <Space size={10}/>
        <Centered>
            <div style={{ maxWidth: 500 }}>
                <Wrapper>
                    <Typography component="h1" variant="h4" align="center" gutterBottom>
                        {t("menu:modifiersSet.addFirstModifier")}
                    </Typography>
                    <Typography component="h4" variant="body2" align="left" gutterBottom>
                        {t("menu:modifiersSet.modifierDescription")}
                        <br/> <br/>
                        {t("menu:modifiersSet.setHasType")} <b>{t("menu:modifiersSet.oneFromList")}</b>.
                        {t("menu:modifiersSet.clientChooseOneOptionFromList")}
                        <br/> <br/>
                        {t("menu:modifiersSet.exampleOfUses")}
                        <br/>
                        {t("menu:modifiersSet.pizzaSize")}
                        <br/>
                        {t("menu:modifiersSet.drinksSize")}
                        <br/>
                        {t("menu:modifiersSet.chooseSoupInBusinessLunch")}
                    </Typography>
                    <br/>

                    <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                        <Button variant="contained"
                                color="primary"
                                onClick={props.openForm}
                        >
                            <AddIcon/>
                            {t("menu:modifiersSet.addModifier")}
                        </Button>
                    </div>

                </Wrapper>
            </div>
        </Centered>
    </>
};


export default observer(NoModifiersInChooseOneSet);
